'use client';

import { Help, Info } from '../../icons';
import { styled } from '../../styles';

export const TooltipContainer = styled.div(({ theme }) => ({
  padding: theme.spacing(2),
  ':dir(rtl) div': {
    textAlign: 'left',
  },
}));

export const TooltipHelpIcon = styled(Help)(({ theme }) => ({
  color: theme.palette.text3,
}));

export const TooltipInfoIcon = styled(Info)(({ theme }) => ({
  color: theme.palette.text4,
  cursor: 'pointer',
}));

export const TooltipTitleContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
